var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlugandpay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 341.3 341.3",
    style: {
      enableBackground: "new 0 0 341.3 341.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#0097FB;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.5,168.2L53.5,168.2c-5.1,5.1-5.1,13.5,0,18.6c5.1,5.1,13.5,5.1,18.6,0c5.1-5.1,5.1-13.5,0-18.6 C67,163.1,58.6,163.1,53.5,168.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M111.3,164.1L111.3,164.1c-7.4,7.4-7.4,19.4,0,26.8c7.4,7.4,19.4,7.4,26.8,0c15.7-15.7,24.5-4.9,34,4.5 c9.9,9.9,26,9.9,35.8,0c9.9-9.9,9.9-26,0-35.8c-9.9-9.9-26-9.9-35.8,0h0c-9.5,9.5-18.3,20.3-34,4.5 C130.7,156.7,118.7,156.7,111.3,164.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52.9,331.6L52.9,331.6c-5.4-5.4-5.4-14.3,0-19.8c5.4-5.4,14.3-5.4,19.8,0c5.4,5.4,5.4,14.3,0,19.8v0 C67.2,337,58.3,337,52.9,331.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M245,83.5L245,83.5c-15.2,15.2-16.6,23.5-37.4,2.7c-9.6-9.6-25.4-9.6-35,0c-9.6,9.6-9.6,25.4,0,35 c9.6,9.6,25.4,9.6,35,0c20.8-20.8,22.2-12.5,37.4,2.7c11.1,11.1,29.3,11.1,40.4,0c11.1-11.1,11.1-29.3,0-40.4 C274.3,72.4,256.1,72.4,245,83.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M111.8,334.9L111.8,334.9c-7.2-7.2-7.8-19.6,0-26.3c25.4-21.8-10.4-64.4-38.3-48.2c-7.2,4.2-15.6,5.9-21.5,0 c-3-3-4.4-6.9-4.4-10.8c0-3.9,1.5-7.8,4.4-10.8c5.9-5.9,15.6-5.9,21.5,0c11.1,11.1,28.8,3.9,37.2-4.4c8.4-8.4,22-8.4,30.4,0 c4.2,4.2,6.3,9.7,6.3,15.2c0,5.5-2.1,11-6.3,15.2v0c-11.3,11.3-14.6,32.1-2.9,43.7c7.2,7.2,7.2,19.1,0,26.3 C130.9,342.1,119.1,342.1,111.8,334.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M111.3,90.3L111.3,90.3c-7.4,7.4-7.4,19.4,0,26.8v0c7.4,7.4,19.4,7.4,26.8,0v0c7.4-7.4,7.4-19.4,0-26.8 C130.7,83,118.7,83,111.3,90.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.5,17.1L53.5,17.1c-5.1,5.1-5.1,13.5,0,18.6c5.1,5.1,13.5,5.1,18.6,0c5.1-5.1,5.1-13.5,0-18.6 C67,11.9,58.6,11.9,53.5,17.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M111.3,13L111.3,13c-7.4,7.4-7.4,19.4,0,26.8c7.4,7.4,19.4,7.4,26.8,0c15.7-15.7,24.5-4.9,34,4.5 c9.9,9.9,26,9.9,35.8,0c9.9-9.9,9.9-26,0-35.8c-9.9-9.9-26-9.9-35.8,0h0c-9.5,9.5-18.3,20.3-34,4.5C130.7,5.6,118.7,5.6,111.3,13"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlugandpay);
export default __webpack_public_path__ + "static/media/plugandpay.6ee2e54e55deec1a72697c4ffa7edf18.svg";
export { ForwardRef as ReactComponent };